React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_background_prompt')

module.exports = class BoardBackgroundPromptTooltip extends React.Component
  displayName: 'BoardBackgroundPromptTooltip'
  render: t.renderable ->
    t.div '.board-background-prompt--tooltip', =>
      t.h3 =>
        t.format 'want-to-see-more'
      t.p =>
        t.format 'you-can-change-backgrounds'
      t.a {
        href: '#'
        onClick: => @props.onDismiss()
      }, =>
        t.format 'got-it-dismiss'
